import React from "react";

const SpeakingAbilityIcon = (props) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="37"
      height="37"
      rx="18.5"
      fill="none"
    />
    <g clipPath="url(#clip0_4466_7048)">
      <path
        d="M27.3574 10.6426V27.3569"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6683 24.9909C10.6677 25.2222 10.7294 25.4494 10.8471 25.6486C10.9648 25.8477 11.134 26.0114 11.3369 26.1223C11.5323 26.2352 11.754 26.2946 11.9797 26.2946C12.2054 26.2946 12.4271 26.2352 12.6226 26.1223L21.8669 20.0795C22.0473 19.963 22.1957 19.8031 22.2984 19.6144C22.4011 19.4257 22.455 19.2144 22.455 18.9995C22.455 18.7847 22.4011 18.5733 22.2984 18.3847C22.1957 18.196 22.0473 18.0361 21.8669 17.9195L12.5969 11.9281C12.4014 11.8153 12.1797 11.7559 11.954 11.7559C11.7283 11.7559 11.5066 11.8153 11.3111 11.9281C11.1083 12.0391 10.9391 12.2028 10.8214 12.4019C10.7037 12.6011 10.642 12.8282 10.6426 13.0595L10.6683 24.9909Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4466_7048">
        <rect width="18" height="18" fill="white" transform="translate(10 10)" />
      </clipPath>
    </defs>
  </svg>
);

export default SpeakingAbilityIcon;